import React from 'react'
import Spinner from 'react-spinkit'
import './index.css'

export default () => {
  return <Spinner spinnerName="chasing-dots" className="loading-indicator" />
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/loading-indicator/index.js